/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramFavouritesUserControllerFindAllQueryResponse,
  TelegramFavouritesUserControllerFindAllQueryParams,
  TelegramFavouritesUserControllerFindAll401,
} from '../../types/TelegramFavouritesUserControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramFavouritesUserFindAll } from '../../methods/telegramFavouritesUserFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramFavouritesUserFindAllQueryKey = (params?: TelegramFavouritesUserControllerFindAllQueryParams) =>
  [{ url: '/api/user/telegram/favourites' }, ...(params ? [params] : [])] as const;

export type TelegramFavouritesUserFindAllQueryKey = ReturnType<typeof telegramFavouritesUserFindAllQueryKey>;

export function telegramFavouritesUserFindAllQueryOptions(
  params?: TelegramFavouritesUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramFavouritesUserFindAllQueryKey(params);
  return queryOptions<
    TelegramFavouritesUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramFavouritesUserControllerFindAll401>,
    TelegramFavouritesUserControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramFavouritesUserFindAll(params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/favourites}
 */
export function useTelegramFavouritesUserFindAll<
  TData = TelegramFavouritesUserControllerFindAllQueryResponse,
  TQueryData = TelegramFavouritesUserControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramFavouritesUserFindAllQueryKey,
>(
  params?: TelegramFavouritesUserControllerFindAllQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramFavouritesUserControllerFindAllQueryResponse,
        ResponseErrorConfig<TelegramFavouritesUserControllerFindAll401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramFavouritesUserFindAllQueryKey(params);

  const query = useQuery(
    {
      ...telegramFavouritesUserFindAllQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramFavouritesUserControllerFindAll401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
